import { Component, OnInit, Inject } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { Router } from "@angular/router";
import { RegetrationTab } from "../../shared/contentTypes";
import { environment } from "../../../../environments/environment";
import { RouterHelperService } from "../../services/routerHelper.service";
import { CoreLanguageService } from "../../services/language.service";
import { TermService } from "../../components/term/term.service";
import { ImpressumTermViewModel } from "../../shared/models";

@Component({
  selector: "app-logindialog",
  templateUrl: "./logindialog.component.html",
  styleUrls: ["./logindialog.component.scss"]
})
export class LoginDialogComponent implements OnInit {

  public dialogTitle: string = "";
  public dialogContent: string = "";
  public terms: ImpressumTermViewModel[] = [];

  constructor(
    public bottomSheetRef: MatBottomSheetRef<LoginDialogComponent>,
    private _router: Router,
    @Inject(MAT_BOTTOM_SHEET_DATA) public modulName: string,
    private _coreLanguageService: CoreLanguageService,
    private _routerHelperService: RouterHelperService,
    private _termService: TermService,
    ) { }

  ngOnInit() {
    const me = this;

    me.dialogTitle = me._coreLanguageService.value("phLoginDialog_Title").replace("<customer>", environment.CustomerName);
    if (me.modulName) {
      me.dialogContent = me._coreLanguageService.value("phLoginDialog_Content_ModuleName")
        .replace("<customer>", environment.CustomerName)
        .replace("<modulename>", me.modulName);
    } else {
      me.dialogContent = me._coreLanguageService.value("phLoginDialog_Content").replace("<customer>", environment.CustomerName);
    }

    me._termService.GetImpressumTermViewModel().then(terms => {
      me.terms = terms;
    });
  }

  public navigateToTerms(termID: number) {
    const me = this;
    me._router.navigate(["/termcondition", termID]);
    me.bottomSheetRef.dismiss();
  }

  public navigateToRegister(): void {
    const me = this;
    me.navigateToRegistration(RegetrationTab.Register);
  }

  public navigateToLogin(): void {
    const me = this;
    me.navigateToRegistration(RegetrationTab.Login);
  }

  private navigateToRegistration(tabIndex: number): void {
    const me = this;
    me._routerHelperService.setRouteTargetDataByKey("returnUrl", me._router.routerState.snapshot.url);
    me._routerHelperService.setRouteTargetDataByKey("tabIndex", tabIndex);
    me._router.navigateByUrl("/registration");
    me.bottomSheetRef.dismiss();
  }
}
